import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { localize } from '@saviynt/common';

import fixLocaleEncoding from '../utils/fixLocaleEncoding';

/**
 * Custom hook for localizing text using the `react-intl` and `@saviynt/common` libraries.
 *
 * @returns A function that takes a key and optional placeholders, and returns the localized text.
 * @example
 * const localizedText = useLocalize();
 * const translatedText = localizedText('translationKey', { param1: 'value1', param2: 'value2' });
 */
const useLocalize = () => {
  const intl = useIntl();

  return useCallback(
    (
      key: string | { id: string; defaultMessage: string },
      placeholders?: object
    ): string => fixLocaleEncoding(localize(intl, key, placeholders)),
    [intl]
  );
};

// eslint-disable-next-line import/prefer-default-export
export { useLocalize };
